// @flow
import { useCallback, useState } from 'react';

export default function useFormManager() {
    const [showValidationErrors, setShowValidationErrors] = useState(false);

    const notNullValidator = useCallback((text: string) => (text.length === 0 ? 'Missing required entry' : null), []);

    const emailValidator = useCallback((text: string) => {
        if (text.length === 0) return 'Missing required entry';
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(text)) return 'Invalid email address';
        return null;
    }, []);

    return {
        showValidationErrors,
        setShowValidationErrors,
        notNullValidator,
        emailValidator
    };
}
